import { render, staticRenderFns } from "./OrderFood.vue?vue&type=template&id=45efaf50&scoped=true"
import script from "./OrderFood.vue?vue&type=script&lang=js"
export * from "./OrderFood.vue?vue&type=script&lang=js"
import style0 from "./OrderFood.vue?vue&type=style&index=0&id=45efaf50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45efaf50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45efaf50')) {
      api.createRecord('45efaf50', component.options)
    } else {
      api.reload('45efaf50', component.options)
    }
    module.hot.accept("./OrderFood.vue?vue&type=template&id=45efaf50&scoped=true", function () {
      api.rerender('45efaf50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver/components/OrderFood.vue"
export default component.exports